import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import { SystemConstants } from '@datatox-bi/util';

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                py: 3, // padding top and bottom
                px: 2, // padding left and right
                mt: 'auto', // margin top auto for pushing to the bottom
                backgroundColor: (theme) => theme.palette.grey[200], // background color
            }}
        >
            <Container maxWidth="lg">
                {/* <Typography variant="body1" align="center">
                    Meu Incrível Site
                </Typography> */}
                <Typography variant="body2" color="text.secondary" align="center">
                    {SystemConstants.Strings.prefixFooter}
                    <Link color="inherit" href={SystemConstants.SiteLink.datatox}>
                        {SystemConstants.Strings.nomeSistema}
                    </Link>{' '}
                    {new Date().getFullYear()}
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;
